import api from '../../helpers/api';
import { history } from '../../helpers';
import { AddAlert } from '../../component';
import { acceptTermsOfUse } from '../../helpers/manageStorage';
import {
  setCityList,
  setSelectedCity,
} from '../../modules/mapSearch/redux/mapSearch.reducer';
import { initialCity } from '../../modules/mapSearch/controllers/citySelect.controller';
import { POC_PROFILES } from '../constants';

export const SIDEBAR_LEFT = 'SIDEBAR_LEFT';
export const setSidebarLeft = (e) => ({
  type: SIDEBAR_LEFT,
  payload: e,
});

export const SIDEBAR_RIGHT = 'SIDEBAR_RIGHT';
export const setSidebarRigth = (e) => ({
  type: SIDEBAR_RIGHT,
  payload: e,
});

export const MODAL_OPEN = 'MODAL_OPEN';
export const modalOpen = (e) => ({
  type: MODAL_OPEN,
  payload: e,
});

export const USER_LOGGED_LOADED = 'USER_LOGGED_LOADED';
export const setUserLoggedLoaded = (e) => ({
  type: USER_LOGGED_LOADED,
  payload: e,
});

export const SET_PROFILE_RULES = 'SET_PROFILE_RULES';
export const setProfileRules = (e) => ({
  type: SET_PROFILE_RULES,
  payload: e,
});

export const USER_LOGGED_PREFERENCE = 'USER_LOGGED_PREFERENCE';
export const setsetUserLoggedPreference = (e) => ({
  type: USER_LOGGED_PREFERENCE,
  payload: e,
});

export const LOG_IN = 'LOG_IN';
export const setLogIn = (e) => ({
  type: LOG_IN,
  payload: e,
});

export const LOG_IN_MESSAGE = 'LOG_IN_MESSAGE';
const setLogInMessage = (e) => ({
  type: LOG_IN_MESSAGE,
  payload: e,
});

export const LOADING = 'LOADING';
export const loading = (_) => ({
  type: LOADING,
});

export const LOADED = 'LOADED';
export const loaded = (_) => ({
  type: LOADED,
});

export const MODE_SCREEN = 'MODE_SCREEN';
export const setModeScreen = (e) => ({
  type: MODE_SCREEN,
  payload: e,
});

export const UPDATE_TERMS_OF_USE = 'UPDATE_TERMS_OF_USE';
export const updateTermsOfUse = (e) => ({
  type: LOADED,
  payload: e,
});

export const termsOfUseAccept =
  ({ version }) =>
  (dispatch) => {
    const terms = { accept: true, version: version || '' };
    sessionStorage.setItem('terms_of_use', JSON.stringify(terms));
    acceptTermsOfUse();
    dispatch(updateTermsOfUse(terms));
  };

export const passwordRecovery = (payload) => {
  return (dispatch) => {
    dispatch(loading());
    api
      .post('/developer/platform/manager/public/retrieve-password', payload)
      .then((res) => {
        if (res.status === 200) {
          dispatch(AddAlert('success', 'E-mail enviado com sucesso'));
          dispatch(loaded());
        }
      })
      .catch((err) => {
        console.error(err);
        dispatch(loaded());
      });
  };
};

export const passwordChange = (payload, id) => {
  return (dispatch) => {
    dispatch(loading());
    api
      .post(`/developer/platform/manager/public/change-password/${id}`, payload)
      .then((res) => {
        if (res.data.code === 200) {
          dispatch(AddAlert('success', res.data.message));
          history.push('/login');
        }
      })
      .finally((_) => dispatch(loaded()));
  };
};

export const UserInfo = (userID, redirectTo) => (dispatch) => {
  api
    .get(`/developer/platform/manager/collaborators/${userID}`)
    .then((res) => {
      history.push(redirectTo);
    })
    .catch((err) => console.error(err))
    .finally(() => dispatch(loaded()));
};

export const LogInAction = (emailPassword, redirectTo = '/map/dashboard') => {
  return (dispatch) => {
    try {
      dispatch(loading());
      api
        .post(`/developer/platform/manager/public/sign-in`, emailPassword)
        .then((response) => {
          const {
            AccessToken,
            ExpiresIn,
            IdToken,
            RefreshToken,
            TokenType,
            logged_user,
          } = response.data.data || {};
          const {
            id,
            name,
            company_id,
            terms_of_use,
            cities,
            default_city,
            platforms,
            company_name,
          } = logged_user || {};
          const initialUserCity = initialCity({
            cities,
            defaultCity: default_city,
          });
          sessionStorage.setItem('AccessToken', AccessToken);
          sessionStorage.setItem('ExpiresIn', ExpiresIn);
          sessionStorage.setItem('IdToken', IdToken);
          sessionStorage.setItem('RefreshToken', RefreshToken);
          sessionStorage.setItem('TokenType', TokenType);
          sessionStorage.setItem('token', AccessToken);
          sessionStorage.setItem('user_id', id);
          sessionStorage.setItem('user_name', name);
          sessionStorage.setItem('company_id', company_id);
          sessionStorage.setItem('terms_of_use', JSON.stringify(terms_of_use));
          sessionStorage.setItem('cities', JSON.stringify(cities));
          sessionStorage.setItem(
            'defaultCity',
            JSON.stringify(initialUserCity)
          );
          const profileRules = platforms.filter(
            (el) => el.platform_name === 'Developer'
          )[0];

          dispatch([
            setLogIn(true),
            setUserLoggedLoaded(logged_user),
            setLogInMessage(''),
            setCityList(cities),
            setSelectedCity(initialUserCity),
            setUserPermissions(profileRules, company_name),
            // setProfileRules(response.data.data.logged_user.platforms),
            history.push(redirectTo),
          ]);
        })
        .catch((error) => {
          console.error(error);
          dispatch([
            setLogIn(false),
            setLogInMessage('Credenciais inválidas'),
            loaded(),
          ]);
        })
        .finally(() => {
          dispatch(loaded());
        });
    } catch (error) {
      console.error(error.message);
    }
  };
};

export const setUserPermissions = (userPermissions, company) => {
  const companyName = company?.toLowerCase();

  let hasAccessPrimary,
    hasAccessSecondary,
    hasAccessTransactions,
    hasAccessGeneralMarkets,
    profileRules;

  let dataLayerAccessRules = {
    hasAccessDistricts: false,
    hasAccessZoning: false,
    hasAccessValueZoning: false,
  };

  if (JSON.parse(sessionStorage.getItem('profileRules')) !== null) {
    profileRules = JSON.parse(sessionStorage.getItem('profileRules'));
  } else {
    hasAccessPrimary =
      userPermissions?.modules?.filter((el) => el.name === 'mercado_primario')
        .length > 0;

    hasAccessSecondary =
      userPermissions?.modules?.filter((el) => el.name === 'mercado_secundario')
        .length > 0;

    hasAccessTransactions =
      userPermissions?.modules?.filter(
        (el) => el.name === 'mercado_transacionados'
      ).length > 0;

    if (companyName === POC_PROFILES[0] || companyName === POC_PROFILES[1]) {
      hasAccessGeneralMarkets = true;
    }

    const dataLayerRules = userPermissions?.modules?.filter(
      (el) => el.name === 'camada_de_dados'
    )[0];

    if (dataLayerRules) {
      const hasAccessDistricts =
        dataLayerRules.module_rules.filter((el) => el === 'districts').length >
        0;
      const hasAccessZoning =
        dataLayerRules.module_rules.filter((el) => el === 'zoning').length > 0;
      const hasAccessValueZoning =
        dataLayerRules.module_rules.filter((el) => el === 'value_zones')
          .length > 0;

      dataLayerAccessRules = {
        hasAccessDistricts,
        hasAccessZoning,
        hasAccessValueZoning,
      };
    }

    profileRules = {
      hasAccessPrimary,
      hasAccessSecondary,
      hasAccessTransactions,
      hasAccessGeneralMarkets,
      dataLayerAccessRules,
    };
  }
  sessionStorage.setItem('profileRules', JSON.stringify(profileRules));
  return (dispatch) => {
    dispatch(setProfileRules(profileRules));
  };
};

export const revalidateCredentials = (e) => {
  const payload = {
    refresh_token: e,
  };
  return (dispatch) => {
    api
      .post(`/developer/platform/manager/public/refresh`, payload)
      .then((response) => {
        sessionStorage.setItem(
          'AccessToken',
          response.data.data.AuthenticationResult.AccessToken
        );
        sessionStorage.setItem(
          'ExpiresIn',
          response.data.data.AuthenticationResult.ExpiresIn
        );
        sessionStorage.setItem(
          'IdToken',
          response.data.data.AuthenticationResult.IdToken
        );
        sessionStorage.setItem(
          'TokenType',
          response.data.data.AuthenticationResult.TokenType
        );
        sessionStorage.setItem(
          'token',
          response.data.data.AuthenticationResult.AccessToken
        );
      })
      .catch((err) => {
        dispatch(
          AddAlert('warning', 'Seu token expirou, faça login novamente')
        );
        console.error(err);
        dispatch(loaded());
      });
  };
};

export const LogedAction = (e) => {
  return (dispatch) => {
    if (sessionStorage.token) {
      api
        .get(`/${sessionStorage.token}`)
        .then((response) => {
          dispatch([setLogIn(true), setUserLoggedLoaded(response.data)]);
        })
        .catch(() => {
          dispatch([setLogIn(false)]);
        });
    }
  };
};

export const LogOutAction = (e) => {
  sessionStorage.clear();
  return (dispatch) => [
    dispatch([setLogIn(false), modalOpen(''), setUserLoggedLoaded({})]),
    window.location.reload(),
  ];
};
